// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

export const tabletMinPx = 600
export const tabletMin = `${tabletMinPx}px`

export const desktopMinPx = 1024
export const desktopMin = `${desktopMinPx}px`

export const desktopSmallPx = 1366
export const desktopSmall = `${desktopSmallPx}px`
